import React from "react";
import RestaurantItem from "./RestaurantItem";
import styles from "./RestaurantList.module.css";
import { categorizeArrByKey } from "utils/utils";
import RestaurantListSkeleton from "./skeleton/RestaurantListSkeleton";
import ScrollContent from "components/UI/ScrollContent";

function RestaurantFloors({ list, loading }) {
  if (!list || loading) {
    return <RestaurantListSkeleton />;
  }

  const restaurants = categorizeArrByKey(list, "floor_name");

  return (
    <ScrollContent mr={20}>
      {restaurants &&
        Object.keys(restaurants).map((key) => (
          <div key={key}>
            <h4 className={styles.floors_title}>{key}</h4>
            <div className={styles.floors_wrapp_item}>
              {restaurants[key].map((restaurant) => (
                <div
                  className={styles.item}
                  key={`${restaurant.id}-${restaurant.code}`}
                >
                  <RestaurantItem
                    id={restaurant.id}
                    name={restaurant.title}
                    phone={restaurant.phone}
                    thumb={restaurant.thumb}
                    code={restaurant.code}
                    promotion_tag={restaurant.promotion_tag}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
    </ScrollContent>
  );
}

export default RestaurantFloors;
